import { isValidElement, Children, ReactNode } from 'react';
import {
  CollectionPageHeader,
  CollectionPageHeaderElement,
} from '../../components/CollectionPageHeaderNew';
import {
  CollectionPageContent,
  CollectionPageContentElement,
} from '../../components/CollectionPageContent';

export function useCollectionPageChild(children: ReactNode) {
  // Mapping to raw WDS components since original Page filtering none expected components: https://github.com/wix-private/wix-design-systems/blob/master/packages/wix-style-react/src/Page/Page.js#L626
  return Children.toArray(children)
    .map((child) => {
      if (isValidElement(child)) {
        switch (child.type) {
          case CollectionPageHeader:
            const header = child as CollectionPageHeaderElement;
            return header.type.useCollectionPageHeader(header);
          case CollectionPageContent:
            const content = child as CollectionPageContentElement;
            return content.type.useCollectionPageContent(content);
          default:
            // WIP: Eventually once we will support all child types this will return null
            return child;
        }
      }

      return null;
    })
    .filter((c) => c);
}
